const DibsWatermark = () => {
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 md:hidden z-50">
      <a
        href="https://www.usedibs.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 px-4 py-2 bg-card rounded-full shadow-lg border border-border/50 text-xs text-muted-foreground hover:shadow-xl transition-shadow"
      >
        Powered by{" "}
        <span className="font-semibold text-primary">Dibs</span>
      </a>
    </div>
  );
};

export default DibsWatermark;
